<template>
  <el-container>
    <el-main class="main">
      <img src="/img/logo.png" alt="Kreator" height="200" />
      <p>Aby zalogować się do panelu umożliwiającego zarządzanie kreatorem podaj swój adres e-mail oraz hasło</p>
      {{ loading }}
      <el-form ref="form" :model="this" :disabled="loading">
        <el-form-item>
        <el-input placeholder="E-mail" v-model="email"></el-input>
        </el-form-item>
        <el-form-item>
        <el-input placeholder="Hasło" v-model="password" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loginAttempt">Zaloguj się</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  
  export default {
    name: 'Login',
    data() {
      return {
        email: 'kontakt@mrcode.pl',
        password: 'Tester123!',
        loading: false,
        error: false
      }
    },
    computed: {
      ...mapState('user', ['status'])
    },
    created () {
        // reset login status
        this.logout();
    },
    methods: {
      ...mapActions('user', ['login', 'logout']),
      loginAttempt() {
        console.log('login attempt', this.loading);
        this.loading = true
        console.log(this.loading);

        const { email, password } = this;
        if (email && password) {
          console.log(email, password);
          this.login({ email, password })
              .then(() => this.loading = false)
        } else {
          this.loading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  body {
    font-family: 'Raleway', sans-serif;
  }
  .el-main.main {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    p {
      max-width: 500px;
      margin: 15px auto 30px;
      color: rgb(146, 146, 146);
    }
  }
</style>